/** How long a link works, in words: "24 hours", "1 hour" or "15 minutes". */
export function linkLasts(minutes: number): string {
  const m = Math.max(1, Math.round(minutes));
  if (m % 60 === 0) return m === 60 ? '1 hour' : `${m / 60} hours`;
  return m === 1 ? '1 minute' : `${m} minutes`;
}
